import {
  CONTACT_CREATE_REQUEST_FAIL,
  CONTACT_CREATE_REQUEST_SUCCESS,
  CONTACT_DELETE_REQUEST_FAIL,
  CONTACT_DELETE_REQUEST_SUCCESS,
  CONTACT_FIND_REQUEST_FAIL,
  CONTACT_FIND_REQUEST_SUCCESS,
  CONTACT_UPDATE_REQUEST_FAIL,
  CONTACT_UPDATE_REQUEST_SUCCESS,
  SELECT_CONTACT
} from '../action.types';
import initialValue from '../initial.state';

export default function(state = initialValue.contact, action) {
  switch (action.type) {
    case SELECT_CONTACT:
      return { ...action.contact };
    case CONTACT_CREATE_REQUEST_SUCCESS:
      return state;
    case CONTACT_CREATE_REQUEST_FAIL:
      return state;
    case CONTACT_UPDATE_REQUEST_SUCCESS:
      return state;
    case CONTACT_UPDATE_REQUEST_FAIL:
      return state;
    case CONTACT_DELETE_REQUEST_SUCCESS:
      return state;
    case CONTACT_DELETE_REQUEST_FAIL:
      return state;
    case CONTACT_FIND_REQUEST_SUCCESS:
      return { ...action.payload };
    case CONTACT_FIND_REQUEST_FAIL:
      return state;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/redux/contact/contact.reducer.js